var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header d-flex align-center justify-center"},[_c('div',{staticClass:"logo-container",on:{"click":_vm.redirectToLandingPage}},[_c('img',{staticClass:"header-logo",attrs:{"src":_vm.headerLogo,"alt":"Apotex Favicon"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }